import Storage from "../protocol/Storage";
import { WIDTH_OF_VIDEO_PREVIEW_PANEL } from "../util/Constants";
import { BreakpointMinWidth, getInnerWidth } from "../util/ScreenUtil";

export const WITH_UNIRESIZABLE_COLUMN = {
 ASSET_DETAILS_BLOCK: {
    minWidth: getInnerWidth() - 700,
    maxWidth: getInnerWidth() - 300
 },
 getWidthOfThisComponent: () => {
   if(getInnerWidth() > BreakpointMinWidth.LG) {
     return parseInt(Storage.get(WIDTH_OF_VIDEO_PREVIEW_PANEL));
   } else {
     return getInnerWidth();
   }
 },

 setDefaultWidth: () => {
  const storedWidth = parseInt(Storage.get(WIDTH_OF_VIDEO_PREVIEW_PANEL));
  if(storedWidth) {
    if(getInnerWidth() < storedWidth + 300) {
      Storage.set(WIDTH_OF_VIDEO_PREVIEW_PANEL, getInnerWidth()-350);
    } 
    if(getInnerWidth() > storedWidth + 700) {
      Storage.set(WIDTH_OF_VIDEO_PREVIEW_PANEL, getInnerWidth()-350);
    }
  } else {
    Storage.set(WIDTH_OF_VIDEO_PREVIEW_PANEL, getInnerWidth()-350);
  }
 }
}